import { render, staticRenderFns } from "./Ddjl.vue?vue&type=template&id=3f3c4bf5&"
import script from "./Ddjl.vue?vue&type=script&lang=js&"
export * from "./Ddjl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports